const INITIAL_STATE = {
  showChat: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_SHOW_CHAT":
      return { ...state, showChat: action.payload };
    default:
      return state;
  }
};
